/**
 * Canonical list of frontend feature flags.
 * This is the single source of truth for valid frontend flag names.
 */
export const FeatureFlags = {
  WorkExperienceDescription: 'work_experience_description',
  SynteaChatbot: 'syntea_chatbot',
  AusweisUpload: 'ausweis_upload',
} as const

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags]
